import { isEmptyData } from '../../../utils/helper';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Outlet from '../Outlet';
import { ArrowLeftIcon } from '@heroicons/react/24/solid';
import Loader from '../../../components/Loader';
import { getCategoryDetail } from '../../../store/reducers/category';
import useNearBottom from '../../../hook/useNearBottom';
import { LoaderIcon } from '../../../utils/svg';

const GroupDetail = (props) => {
	const { id, name, onClose } = props;

  const dispatch = useDispatch();
	const scrollRef = useRef(null);
	const { isNearBottom } = useNearBottom(200, scrollRef);
	const user = useSelector((store) => store.user);
  const { isLoadingDetail, isLoadMoreDetail, detail } = useSelector((store) => store.category);

	const loadOutlets = async () => {
		try {
			const params = {
				id,
				latitude: user?.latitude,
				longitude: user?.longitude,
				page: !isNearBottom ? 1 : detail?.page + 1,
				limit: 10,
        isLoadMore: isNearBottom,
			}
      dispatch(getCategoryDetail(params))
		} catch (error) {
      console.log('error: ', error);
		}
	};

	useEffect(() => {
		if (!isNearBottom || isEmptyData(id)) return;
		loadOutlets();
	}, [isNearBottom, id]);

	useEffect(() => {
		if (isEmptyData(id)) return;
		loadOutlets();
	}, [id]);

	return (
		<div ref={scrollRef} className='flex flex-col min-h-screen relative bg-white'>
			{isLoadingDetail && <Loader overlay />}
			<div className={`bg-white p-4 flex flex-row items-center border-b-1 border-solid border-gray-200 sticky top-0 min-w-full min-h-10`}>
				<div className='flex flex-row justify-center items-center'>
					<ArrowLeftIcon className={`h-8 w-8 transition-all duration-500text-gray-900 p-1`} onClick={onClose} />
					<div className={`text-gray-700 font-semibold pl-2 text-base transition-all duration-500 truncate max-w-[75vw] opacity-100 transform translate-y-0`}>{name ?? ''}</div>
				</div>
			</div>
			<div className='p-4 flex-1 overflow-x-hidden overflow-y-scroll'>
				<Outlet outlets={detail?.outlets || []} />
			</div>
			{isLoadMoreDetail && (
				<div className='flex justify-center !mt-1'>
					<LoaderIcon />
				</div>
			)}
		</div>
	);
};

export default GroupDetail;
